import React from "react";
import { formatDate, readingTime } from "@/lib/utils";
import { GatsbyImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

// component styles
import "./index.scss";

export const ContentSection = ({ content, date, image, title }: any) => {
  return (
    <div
      id="location__content"
      className="section__container bg__light text__primary"
    >
      <div className="inner-container">
        <div className="inner">
          <div className="inner__presentation">
            <Link to="/news" className="presentation__back">
              Back
            </Link>
            <h1 className="presentation__title">{title}</h1>
            <div className="presentation__info">
              <p>{readingTime(content)}</p>
              <div className="separator"></div>
              <p>{formatDate(date)}</p>
            </div>
            <GatsbyImage
              alt={image.node.altText}
              image={image.node.gatsbyImage}
              className="presentation__image"
            />
          </div>
          <div
            className="inner__content"
            dangerouslySetInnerHTML={{
              __html: content,
            }}
          />
        </div>
      </div>
    </div>
  );
};
